import React from "react";
import Index from "../Index";
import * as XLSX from "xlsx-color";
import { getAccountMasterListApiHandler } from "../../services/AdminIndex";
import { toast } from "react-toastify";

export default function ExportSampleSheetOpeningBalance(props) {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  //   const fileType = "text/csv;charset=utf-8";
  //   const fileExtension = ".csv";
  const exportToCSV = (headerKeys, fileName) => {
    getAccountMasterListApiHandler(props?.token, "", 0).then(async (data) => {
      if (data.status === 201 || data.status === 200) {
        const responseData = data?.data;

        const applyCellStyle = (cell, style, ws) => {
          ws[cell].s = {
            font: {
              color: { rgb: style?.fontColor || "FFFFFF" },
              bold: style.bold,
            },
            alignment: { horizontal: "center", vertical: "center" },
          };
        };

        const wsData = [];

        // Add Header Row
        wsData.push(headerKeys);

        // Add Data Rows
        responseData.forEach((item) => {
          wsData.push([
            item.id || "", // AccountId
            item.accountName || "", // AccountName
            item.gropId || "", // GroupId
            item.GroupName || "", // GroupName
            "", // BalanceType (empty)
            "", // Amount (empty)
          ]);
        });

        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Style header row (Row 0)
        const RowA = headerKeys.map((_, colIndex) =>
          XLSX.utils.encode_cell({ r: 0, c: colIndex })
        );

        const stylesRowA = headerKeys.map((_, index) => ({
          bold: false,
          fontColor: props?.requiredIndex?.includes(index)
            ? "FF0000"
            : "000000",
        }));

        RowA.forEach((cell, index) => {
          applyCellStyle(cell, stylesRowA[index], ws);
        });

        // Column width
        ws["!cols"] = headerKeys.map(() => ({ wch: 15 }));

        // Workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, fileName);

        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName + ".xlsx";
        link.click();
      } else {
        toast.error("Account Ledger not found to export");
      }
    });
  };

  return (
    <Index.Box className="btn-primary-main">
      <Index.Button
        className={props.className}
        onClick={(e) => exportToCSV(props?.headerKeys, props?.fileName)}
        disableRipple
        disabled={props.disabled}
      >
        {props.btnLabel}
      </Index.Button>
    </Index.Box>
  );
}
